var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0974 5.95495C13.0046 6.02695 11.3661 6.95024 11.3661 9.00325C11.3661 11.3779 13.4511 12.218 13.5135 12.2388C13.5039 12.29 13.1822 13.3893 12.4142 14.5094C11.7293 15.4951 11.014 16.4792 9.92592 16.4792C8.83781 16.4792 8.55778 15.8471 7.30165 15.8471C6.07753 15.8471 5.64229 16.5 4.64699 16.5C3.65169 16.5 2.95722 15.5879 2.15874 14.4678C1.23385 13.1525 0.486572 11.1091 0.486572 9.16967C0.486572 6.05896 2.50917 4.40919 4.49977 4.40919C5.55748 4.40919 6.43917 5.10366 7.10323 5.10366C7.7353 5.10366 8.721 4.36759 9.92432 4.36759C10.3804 4.36759 12.0189 4.40919 13.0974 5.95495ZM9.35306 3.05065C9.85071 2.4602 10.2027 1.64091 10.2027 0.821632C10.2027 0.708021 10.1931 0.592809 10.1723 0.5C9.36266 0.530403 8.39936 1.03925 7.81851 1.71292C7.36246 2.23137 6.93682 3.05065 6.93682 3.88114C6.93682 4.00595 6.95762 4.13076 6.96722 4.17077C7.01843 4.18037 7.10163 4.19157 7.18484 4.19157C7.91131 4.19157 8.82501 3.70512 9.35306 3.05065Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.35b47b019533a99c6b38dd4c57a4844b.svg";
export { ForwardRef as ReactComponent };